import {AbstractVisualFeature, allVisuals} from '../visual-feature.js';

import {dialogsConfig} from './dialogs.factory';

import PALETTE_SCHEMA from './dialogs.palette-schema.yaml';

class DialogsFeature extends AbstractVisualFeature {
    get name() {
        return 'Dialogs';
    }

    get paletteSchema() {
        return PALETTE_SCHEMA;
    }

    getSerializableVisualConfig(PALETTE) {
        return dialogsConfig(PALETTE);
    }
}

export const Dialogs = new DialogsFeature(allVisuals);
